export function createTranscriptionError(message, { code, phase } = {}) {
  const error = new Error(message);
  if (code) error.code = code;
  if (phase) error.phase = phase;
  return error;
}

export function annotateTranscriptionError(error, { code, phase } = {}) {
  const normalized = error && typeof error === 'object'
    ? error
    : new Error(String(error || 'Unknown error'));

  try {
    if (code && !normalized.code) normalized.code = code;
    if (phase && !normalized.phase) normalized.phase = phase;
    return normalized;
  } catch (_) {
    const wrapped = new Error(String(normalized.message || normalized));
    wrapped.name = String(normalized.name || 'Error');
    wrapped.code = normalized.code || code;
    wrapped.phase = normalized.phase || phase;
    return wrapped;
  }
}

export function getErrorDiagnostics(error) {
  return {
    code: error?.code ? String(error.code) : null,
    message: String(error?.message || error || 'Unknown error'),
    name: String(error?.name || 'Error'),
    phase: error?.phase ? String(error.phase) : null,
    stack: String(error?.stack || 'unavailable'),
  };
}
